<template>
<div id="c-mainContainer" class="c-mainContainer">
  <common-header></common-header>
  <mv-fv name="block0"></mv-fv>
  <mv-col1 name="block1"></mv-col1>
  <mv-main-text name="block2"></mv-main-text>
  <mv-main2 name="block3"></mv-main2>
  <mv-main2 name="block4"></mv-main2>
  <mv-main2 name="block5"></mv-main2>
  <carousel2 name="carousel1"></carousel2>
  <mv-main-text name="block6"></mv-main-text>
  <mv-main2 name="block7"></mv-main2>
  <mv-main2 name="block8"></mv-main2>
  <mv-main2 name="block9"></mv-main2>
  <carousel2 name="carousel2"></carousel2>
  <mv-main-text name="block10"></mv-main-text>
  <mv-main2 name="block11"></mv-main2>
  <mv-main2 name="block12"></mv-main2>
  <carousel2 name="carousel3"></carousel2>
  <mv-col1 name="block13"></mv-col1>
  <mv-main-text name="block14"></mv-main-text>
  <mv-main2 name="block15"></mv-main2>
  <mv-main2 name="block16"></mv-main2>
  <mv-main2 name="block17"></mv-main2>
  <carousel2 name="carousel4"></carousel2>
  <mv-col1 name="block18"></mv-col1>
  <mv-main-text name="block19"></mv-main-text>
  <mv-main2 name="block20"></mv-main2>
  <mv-main2 name="block21"></mv-main2>
  <mv-col1 name="block22"></mv-col1>
  <mv-main-text name="block23"></mv-main-text>
  <mv-main2 name="block24"></mv-main2>
  <carousel2 name="carousel5"></carousel2>
  <mv-main-text name="block25"></mv-main-text>
  <mv-main2 name="block26"></mv-main2>
  <carousel2 name="carousel6"></carousel2>
  <mv-col1 name="block27"></mv-col1>
  <mv-main-text name="block28"></mv-main-text>
  <mv-col1 name="block29"></mv-col1>
  <mv-main-text name="block30"></mv-main-text>
  <mv-main2 name="block31"></mv-main2>
  <mv-main2 name="block32"></mv-main2>
  <mv-main2 name="block33"></mv-main2>
  <carousel2 name="carousel7"></carousel2>
  <common-footer></common-footer>
</div>
</template>

<script>
import {gsap, Power2, Power3} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, ScrollToPlugin);
// ScrollTrigger.normalizeScroll(true);
ScrollTrigger.normalizeScroll(false);
ScrollTrigger.config({ignoreMobileResize: true});

import CommonHeader from '@/_components/CommonHeader';
import CommonFooter from '@/_components/CommonFooter';
import MvFv from '@/_components/MvFv';
import MvMain1 from '@/_components/MvMain1';
import MvMain2 from '@/_components/MvMain2';
import MvMain3 from '@/_components/MvMain3';
import MvMain4 from '@/_components/MvMain4';
import MvMainText from '@/_components/MvMainText';
import MvMainText2 from '@/_components/MvMainText2';
import MvCol1 from '@/_components/MvCol1';
import MvCol2 from '@/_components/MvCol2';
import MvCol3 from '@/_components/MvCol3';
import MvFunc from '@/_components/MvFunc';
import Carousel from '@/_components/Carousel';
import Carousel2 from '@/_components/Carousel2';
import CarouselKv from '@/_components/CarouselKv';

export default {
  components: {
    CommonHeader,
    CommonFooter,
    MvFv,
    MvMain1,
    MvMain2,
    MvMain3,
    MvMain4,
    MvMainText,
    MvMainText2,
    MvCol1,
    MvCol2,
    MvCol3,
    MvFunc,
    Carousel,
    Carousel2,
    CarouselKv,
  },
  data() {
    return {
      ss: null,
      isInit: false,
      preWidth: 0,
    }
  },
  computed: {
  },
  mounted() {
    const container = this.$el;
    const observer = new ResizeObserver((entries) => {
      if (gPG.isDevice === 'pc' || this.preWidth !== window.innerWidth) {
        ScrollTrigger.refresh();
      }
      this.preWidth = window.innerWidth;
    });
    observer.observe(container);

    this.$nextTick(this.resize);
  },
  methods: {
    init() {
      if (this.isInit) return;
      this.isInit = true;
      this.ss = ScrollSmoother.create({
        content: '#c-mainContainer',
        ease: Power2,
        effects: false,
        smooth: 0.4,
        smoothTouch: 0.1,
        ignoreMobileResize: true,
        // normalizeScroll: true,
      });
      this.$store.commit('setScrollSmoother', this.ss);
      // ScrollTrigger.normalizeScroll(true);
      ScrollTrigger.refresh();
    },
    // destroy() {
    //   this.isInit = false;
    //   if (this.ss) {
    //     this.ss.kill();
    //     this.ss = null;
    //     this.$store.commit('setScrollSmoother', null);
    //   }
    //   ScrollTrigger.normalizeScroll(false);
    //   ScrollTrigger.refresh();
    // },
    resize() {
      // if (this.getMatchMedia(1000)) {
      //   this.destroy();
      // } else {
        this.init();
      // }
    },
    getMatchMedia(width) {
      return window.matchMedia('(max-width: ' + width +'px)').matches;
    },
  }
}
</script>